export default [
  { value: "Chip", key: 1000 },
  { value: "Spin", key: 1 },
  { value: "Spin win strike", key: 3 },
  { value: "Spin different", key: 4 },
  { value: "Gift Box Win", key: 5 },
  { value: "Play Bingo", key: 6 },
  { value: "Bingo Match", key: 1001 },
];
